import type { CSSProperties } from 'react';

export const getWrapperStyle = (
  width?: number | string,
  height?: number | string,
  style?: CSSProperties,
): CSSProperties | undefined => {
  if (width === undefined && height === undefined && style === undefined) {
    return undefined;
  }

  const wrapperStyle: CSSProperties = { ...style };

  if (width !== undefined) {
    wrapperStyle.width = typeof width === 'number' ? `${width}px` : width;
  }

  if (height !== undefined) {
    wrapperStyle.height = typeof height === 'number' ? `${height}px` : height;
  }

  return wrapperStyle;
};
